module.exports = __webpack_public_path__ + "static/media/icon-parametrizacao.551d5d04.png";